import { render } from "./ai.vue?vue&type=template&id=0f3df058"
import script from "./ai.vue?vue&type=script&lang=js"
export * from "./ai.vue?vue&type=script&lang=js"

import "./ai.vue?vue&type=style&index=0&id=0f3df058&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__